import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
// import { NgxIntlTelInputComponent } from 'ngx-intl-tel-input';


export function TrimValidator(control: AbstractControl): ValidationErrors | null {
  const value = control?.value;

  if (typeof value !== 'string') {
    return null;
  }

  const newValue = value.replace(/<[^>]*>/g, '');

  if (newValue.trim() === '' && newValue.includes(' ')) {
    return { required: 'Invalid input' };
  }
  return null;
}

export function minAndMaxLengthValidator(min:number = 0, max:number = 0): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const length = !!control?.value?.trim ? (control?.value?.trim()?.length || 0) : 0;

    if (length === 0) return null;

    if (!min && !max) return null;

    if (min && !max) {
      return length < min ? { lengthInvalid: `Min. ${min} characters` } : null
    }

    if (!min && max) {
      return length > max ? { lengthInvalid: `Max. ${max} characters` } : null
    }

    if (min && max) {
      return (length < min || length > max) ? { lengthInvalid: `Must not be less than ${min} characters and not be more than ${max} characters` } : null
    }

    return null; // No error, valid
  };
}


export function NumberDigitValidator(min?:number, max?:number, allowDecimal = true): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Only skip validation if value is empty (null, undefined, or '')
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const number = Number(value);

    if (isNaN(number)) {
      return { invalidNumber: 'Not a valid number' };
    }

    if (!allowDecimal && (number !== Math.round(number))) {
      return { invalidNumber: 'Decimal values are not allowed' };
    }

    const isNil = (value: any) => {
      return value === null || value === undefined
    }

    const formattedMin = Intl.NumberFormat('en-US').format(min || 0);
    const formattedMax = Intl.NumberFormat('en-US').format(max || 0);

    if (isNil(min) && isNil(max)) return null;

    if (!isNil(min) && isNil(max)) return (number < min!) ? { invalidNumber: `Min amount is ${formattedMin}` } : null

    if (isNil(min) && !isNil(max)) return number > max! ? { invalidNumber: `Max amount is ${formattedMax}` } : null

    if (!isNil(min) && !isNil(max)) {
      return (number < min! || number > max!) ? { lengthInvalid: `Allowed values is between ${formattedMin} to ${formattedMax}` } : null
    }

    return null;
  };
}

// export function phoneNumberValidator(phoneInput: NgxIntlTelInputComponent): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const phoneNumber = control.value;
//
//     // Check if the phone number is valid using the `phoneUtil` property
//     if (phoneInput?.phoneUtil) {
//         try {
//           const parsedNumber = phoneInput.phoneUtil.parse(phoneNumber, phoneInput.selectedCountryISO);
//           if (!phoneInput.phoneUtil.isValidNumber(parsedNumber)) {
//             return { 'invalidPhoneNumber': true }; // Invalid phone number
//           }
//         } catch (error) {
//           return { 'invalidPhoneNumber': true }; // Invalid phone number
//         }
//       }
//
//     return null;
//   };
// }

export function matchesValueValidator(matchingControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const matchingValue = matchingControl.value;
        const value = control.value;

        if (!value) {
            return null;
        }

        if (value !== matchingValue) {
            return { 'notMatching': true };
        }

        return null;
    };
}

